import React from 'react';
import { useDropzone } from 'react-dropzone';
import type { DragAndDropProps } from '@components/atoms/drag-and-drop/types';
import type { FileWithPreview } from '@models/types';
import cn from 'classnames';
import { styled } from 'styled-components';

import { DragAndDropWrapper } from './styles';

const Atom: React.FC<DragAndDropProps> = ({
    onChange,
    children,
    isMultiple = false,
    accept = {
        'image/jpeg': [],
        'image/png': [],
        'image/*': [],
    },
    className,
    isDisabled,
}) => {
    const { getRootProps, getInputProps } = useDropzone({
        accept,
        disabled: isDisabled,
        onDrop: (acceptedFiles) => {
            if (isDisabled) return;
            const files = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                }),
            );

            onChange(files as unknown as FileWithPreview[]);
        },
    });

    return (
        <DragAndDropWrapper
            {...getRootProps()}
            className={cn('drag-and-drop', className, {
                'is-disabled': isDisabled,
            })}
        >
            <input {...getInputProps()} multiple={isMultiple} disabled={isDisabled} />
            {children}
        </DragAndDropWrapper>
    );
};

export const DragAndDrop = styled(Atom)({});
